import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { messagesApiQueryKeys } from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';

/** Po ponowieniu czekanie w panelu spraw liczy się od nowa — stąd odświeżenie spraw wyjazdu. */
const useResendChange = (bookingId: string, tourId?: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (changeId) =>
      bookingChangesApi.resendChange(bookingId, changeId),
    onSuccess: () => {
      toast.success('Link do akceptacji wysłany ponownie');
      queryClient.invalidateQueries({
        queryKey: messagesApiQueryKeys.byBooking(bookingId),
      });
      return invalidateAttentionQueries(queryClient, tourId);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się wysłać ponownie', {
        description: error.message,
      });
    },
  });
};

export default useResendChange;
